import React, { useEffect } from 'react';
import EventsBanner from './Components/EventsBanner/index';
import EventsLayout2 from './Components/EventsLayout2';
import ReactGA from 'react-ga4';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EventsPage(_ref) {
  var config = _ref.config,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient,
    isAuthenticated = _ref.isAuthenticated,
    theme = _ref.theme,
    ThemeProvider = _ref.ThemeProvider,
    ComponentsRenderer = _ref.ComponentsRenderer,
    FilterOptions = _ref.FilterOptions,
    onNavigateToDetail = _ref.onNavigateToDetail,
    Banner = _ref.Banner;
  useEffect(function () {
    var _window, _cmsClient$defaults, _cmsClient$defaults2;
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track('EventsPageViewed');
    if (cmsClient && (((_cmsClient$defaults = cmsClient.defaults) === null || _cmsClient$defaults === void 0 ? void 0 : _cmsClient$defaults.baseURL) === 'https://prod.loyalie.in' || ((_cmsClient$defaults2 = cmsClient.defaults) === null || _cmsClient$defaults2 === void 0 ? void 0 : _cmsClient$defaults2.baseURL) === 'https://uat.loyalie.in')) {
      var _window$fbq, _window2;
      (_window$fbq = (_window2 = window).fbq) === null || _window$fbq === void 0 || _window$fbq.call(_window2, 'trackCustom', 'EventsPage');
    }
    if (ReactGA && ReactGA.ga) {
      ReactGA.ga('send', 'pageview', '/events');
    }
  }, [cmsClient]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: "\n                    ".concat(config === null || config === void 0 ? void 0 : config.bannerNegativeTopMarginClass, " w-full h-auto  "),
      children: (config === null || config === void 0 ? void 0 : config.header) && /*#__PURE__*/_jsx("div", {
        className: config === null || config === void 0 ? void 0 : config.header.headerClass
      })
    }), /*#__PURE__*/_jsx(EventsBanner, {
      config: config,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient,
      isAuthenticated: isAuthenticated,
      Banner: Banner
    }), /*#__PURE__*/_jsx(EventsLayout2, {
      config: config,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient,
      isAuthenticated: isAuthenticated,
      theme: theme,
      ThemeProvider: ThemeProvider,
      ComponentsRenderer: ComponentsRenderer,
      FilterOptions: FilterOptions,
      onNavigateToDetail: onNavigateToDetail
    })]
  });
}
export default EventsPage;